<template>
  <div class="outstanding-header">
    <div class="grid-row">
      <div class="c-4 c-lg-4 c-md-12 c-sm-12 c-xs-12">
        <div class="outstanding">
          <span>
            <strong>{{$_('balance')}} :</strong>
            {{tsolde}} {{tcdev_cli}}
          </span>
          <span>
            <strong>{{$_('accounting_outstandings')}} : {{(tencours_nd+tencours_d).toFixed(2)}} {{tcdev_cli}}</strong>
          </span>
        </div>
      </div>
      <div class="c-4 c-lg-4 c-md-12 c-sm-12 c-xs-12">
        <div class="outstanding-warning-container">
          <div class="outstanding-warning-logo"></div>
          <div class="outstanding-warning-ammount">
            <span>
              <i>{{$_('your_outstanding_amount_is_exceeded_by')}}:</i>
            </span>
            <span>{{tencours_d}} {{tcdev_cli}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import outstandingService from "@/modules/encour/services/outstandingService";

export default {
  name: "OutstandingHeader",
  data() {
    return {
      tsolde: 0,
      tencours_nd: 0,
      tencours_d: 0,
      tdepasse1: 0,
      tdepasse2: 0,
      tdepasse3: 0,
      tdepasse4: 0,
      tcontent: 0,
      tcdev: ''
    };
  },
  created() {
    outstandingService
      .getOutStandingHeader()
      .then(res => {
        if (res.data.DS_O !== undefined) {
          let data = res.data.DS_O.OUT;

          this.tsolde = data.TSOLDE;
          this.tencours_nd = data.TENCOURS_ND;
          this.tencours_d = data.TENCOURS_D;
          this.tdepasse1 = data.TDEPASSE1;
          this.tdepasse2 = data.TDEPASSE2;
          this.tdepasse3 = data.TDEPASSE3;
          this.tdepasse4 = data.TDEPASSE4;
          this.tcdev_cli = data.TCDEV_CLI
        }
      })
      .catch(err => console.error(err));
  },
  computed: {}
};
</script>

<style scoped>
.outstanding {
  border: solid 1px #f5f5f5;
  display: flex;
  flex-direction: column;
  padding: 25px;
}
.outstanding-warning-container {
  border: solid 1px #f5f5f5;
  border-left: solid 5px #f00b35;

  display: flex;
  padding: 25px;
}
.outstanding-warning-ammount {
  display: flex;
  flex-direction: column;
}
.outstanding-warning-ammount span {
  color: #f00b35;
}
i {
  font-family: "Lato-Light";
}
</style>